import React from "react";
import { SimpleShowLayout, TextField, NumberInput } from "react-admin";

const FormTab = (props) => {
  function s(p) {
    return props.side + "." + p;
  }
  return (
    <SimpleShowLayout {...props}>
      <TextField source={s("season.team.name")} />
      <TextField source={s("id")} />
      <TextField source={s("girlsvolleyball.id")} />
      <NumberInput source={s("girlsvolleyball.finalScore")} />
      <NumberInput source={s("girlsvolleyball.game1Points")} />
      <NumberInput source={s("girlsvolleyball.game2Points")} />
      <NumberInput source={s("girlsvolleyball.game3Points")} />
      <NumberInput source={s("girlsvolleyball.game4Points")} />
      <NumberInput source={s("girlsvolleyball.game5Points")} />
      <NumberInput source={s("girlsvolleyball.kills")} />
      <NumberInput source={s("girlsvolleyball.aces")} />
      <NumberInput source={s("girlsvolleyball.blocks")} />
      <NumberInput source={s("girlsvolleyball.digs")} />
      <NumberInput source={s("girlsvolleyball.assists")} />
    </SimpleShowLayout>
  );
};

export default FormTab;
